import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppState } from '../../shared/state/app.reducer';
import { select, Store } from '@ngrx/store';
import * as fromLoginSelectors from '../login/state/login.selectors';
import * as fromLoginActions from '../login/state/login.actions';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { Association } from '../../shared/association/association.model';
import { Router } from '@angular/router';

@Component({
  selector: 'lwa-association-access',
  templateUrl: './association-access.component.html',
  styleUrls: ['./association-access.component.scss'],
})
export class AssociationAccessComponent implements OnInit, OnDestroy {

  associations: Association[];

  constructor(private store: Store<AppState>) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.store.dispatch(fromLoginActions.getUserAssociations());

    this.store.pipe(
      untilDestroyed(this),
      select(fromLoginSelectors.selectUserAssociations),
    )
      .subscribe((associations) => {
        if (!!associations) {
          this.associations = associations;
        }
      });
  }

  selectAssociation(event): void {
    this.store.dispatch(fromLoginActions.setCurrentAssociation({ associationId: event.id }));
  }
}
